import request from '@/utils/request';
import authRequest from '@/utils/authRequest';
import { 
  LoginConfigData, 
  AuthorizeRequest, 
  AuthorizeResponse,
  SmsCodeRequest,
  QrCodeResponse,
  QrCodeStatusResponse,
  LoginCodeResponse,
  LoginCodeStatusResponse
} from '@/types/api';

// 获取登录配置
export const getLoginConfig = (poolNo: string): Promise<LoginConfigData> => {
  return request.get('/api/getConfig', { params: { poolNo } });
};

// 获取授权码
export const getAuthorizationCode = (
  data: AuthorizeRequest
): Promise<AuthorizeResponse> => {
  return authRequest.post('/api/oauth2/authorize', data);
};

// 发送短信验证码
export const sendSmsCode = (data: SmsCodeRequest) => {
  return request.post('/api/auth/sendSmsCode', data);
};

// 查询用户关联的应用列表
export const getAppList = () => {
  return authRequest.get('/api/userApps');
};

// 查询用户绑定的三方关系列表
export const getBindThirdPartList = (data: any) => {
  return authRequest.post('/api/queryBindThirdPartList', data);
};

// 解绑三方登录关系
export const unbindThirdPart = (data: any) => {
  return authRequest.post('/api/unBindThirdPart', data);
};

// 查询当前登录用户信息
export const getCurrentUserInfo = () => {
  return authRequest.get('/api/userinfo');
};

// 登出
export const loginOut = () => {
  return authRequest.post('/api/auth/logout', {})
};

// token续期
export const loginRenewal = () => {
  return authRequest.post('/api/oauth2/renewal', {});
};

// 生成绑定码
export const generatedBindCode = (data: any): Promise<QrCodeResponse> => {
  return authRequest.post('/api/generatedBindCode', data);
};

// 检测二维码状态
export const getQrCodeStatus = (bindCode: string): Promise<QrCodeStatusResponse> => {
  return request.post(`/api/checkBindCode`, { bindCode });
};

// 生成登录码
export const generatedLoginCode = (data: { poolNo: string, ext: { configId: number, poolNo: string } }): Promise<LoginCodeResponse> => {
  return request.post('/api/generatedLoginCode', data);
};

// 检测登录码状态
export const checkLoginCode = (data: { loginCode: string }): Promise<LoginCodeStatusResponse> => {
  return request.post('/api/checkLoginCode', data);
};
